import registrationPopup from './registration/popup';
import inportCenterPopup from './import/popup';

export default [...registrationPopup, ...inportCenterPopup];
